(function(){
  'use strict';
  var KEY='podz-cart-review-reminder-start';
  var DURATION_MS=5*60*1000;
  function getStart(){
    try{
      var stored=Number(sessionStorage.getItem(KEY))||0;
      if(stored && stored<=Date.now() && stored>Date.now()-86400000)return stored;
      var next=Date.now();
      sessionStorage.setItem(KEY,String(next));
      return next;
    }catch(e){return Date.now();}
  }
  function renderTimer(){
    var targets=document.querySelectorAll('[data-podz-cart-reminder]');
    if(!targets.length)return;
    var start=getStart();
    var remaining=Math.max(0,DURATION_MS-(Date.now()-start));
    var total=Math.ceil(remaining/1000);
    var display=String(Math.floor(total/60)).padStart(2,'0')+':'+String(total%60).padStart(2,'0');
    targets.forEach(function(el){
      var clock=el.querySelector('[data-podz-clock]');
      if(clock){clock.textContent=display;clock.setAttribute('aria-label',total>0?'Cart timer '+display:'Cart timer complete');}
    });
  }
  renderTimer();
  document.addEventListener('visibilitychange',renderTimer);
  setInterval(function(){if(document.visibilityState!=='hidden')renderTimer();},1000);
})();